// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"ft-z","giftOrPromoSelector":"gt-z","disabled":"ht-z","subTitle":"it-z","selectShipAddressMessage":"jt-z","changePayment":"kt-z"};